<template>
  <v-container fill-height fluid>
    <v-layout pt-5 mt-5 row>
      <v-flex sm10 offset-sm1>
        <v-card class="elevation-0">
          <v-card-title primary-title class="primary--text">
            <h3 class="display-1 mb-0 ml-3">{{ 'shopcart.title' | t }}</h3>
          </v-card-title>
          <v-card-text v-if="loading">
            <v-flex text-md-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-flex>
          </v-card-text>
          <v-card-text v-else>
            <v-layout justify-space-around align-center row>
              <v-flex md6>
                <v-card class="elevation-2 pa-2" color="grey lighten-1">
                  <v-card-title>
                    <span class="headline">{{getShopOndemand.type | capitalize }} On Demand</span>
                  </v-card-title>
                  <v-card-text class="ml-5">
                    <p
                      class="subheading mt-3"
                    >{{getShopOndemand.requests | formatnumber }} {{getShopOndemand.article | capitalize}}</p>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex md4>
                <v-layout row>
                  <v-flex>
                    <v-card class="pa-2" color="blue-grey lighten-4">
                      <h3 class="ma-1">{{ firstname }} {{ lastname }}</h3>
                      <p v-if="company !== ''" class="ma-1">{{ company }}</p>
                      <p class="ma-1">{{ id_card }}</p>
                      <p class="ma-1">{{ address }}</p>
                      <p class="ma-1">{{ postal_code }}, {{ city }}</p>
                      <p class="ma-1">{{ country }}</p>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex pt-4>
                    <v-card class="pa-2" color="blue-grey lighten-4">
                      <p class="ma-1 text-md-right">Baseprice: {{ base_price | currency }} &euro;</p>
                      <p v-if="vat_valid === 0" class="ma-1 text-md-right">Taxes: {{ taxes }} %</p>
                      <p v-else class="ma-1 text-md-right">VAT Non-Taxable</p>
                      <p class="ma-1 text-md-right">Total Price: {{ total_price | currency }} &euro;</p>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-card-text>
              <v-list>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>info</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>La compra de nuevas request no altera el compromiso mensual.</v-list-tile-title>
                    <v-list-tile-title>Los extra request adquiridos estar&aacute;n disponibles hasta fin del ciclo de la facturaci&oacute;n.</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
            <v-layout row>
              <v-flex text-md-right>
                <v-btn color="primary" :disabled="buying" to="/shop">{{ 'shopcart.cancel' | t }}</v-btn>
                <v-btn color="primary" :loading="buying" @click="payNow">CONFIRMAR COMPRA</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      buying: false,
      loading: true,
      firstname: "",
      lastname: "",
      company: "",
      id_card: "",
      address: "",
      postal_code: "",
      city: "",
      country: "",
      base_price: 0,
      taxes: 0,
      total_price: 0,
      vat_valid: 0
    };
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getServer",
      "getTokenHeader",
      "getShopOndemand"
    ])
  },
  created() {
    if ([undefined, "", 0].includes(this.getShopOndemand.total_price)) {
      this.$router.push({ path: "/shop" });
    } else {
      this.$http
        .post(
          `${this.getServer}/orders/ondemand`,
          {
            price: this.getShopOndemand.total_price
          },
          this.getTokenHeader
        )
        .then(({ data }) => {
          if (data.error) {
            this.dialogkey = "problems";
            this.dialog = true;
          } else {
            this.firstname = data.firstname;
            this.lastname = data.lastname;
            this.company = data.company;
            this.id_card = data.id_card;
            this.address = data.address;
            this.postal_code = data.postal_code.toString();
            this.country = data.country_name;
            this.taxes = data.taxes;
            this.base_price = data.base_price;
            this.total_price = data.total_price;
            this.loading = false;
          }
        })
        .catch(() => {
          this.dialogkey = "problems";
          this.dialog = true;
        });
    }
  },
  methods: {
    ...mapActions(["rmKey"]),
    payNow() {
      this.buying = true;

      this.$http
        .post(
          `${this.getServer}/orders/ondemand/confirm`,
          this.getShopOndemand,
          this.getTokenHeader
        )
        .then(() => {
          this.$router.push({ path: "/shop/ondemand/confirm" });
        });
    }
  }
};
</script>
